// @ts-nocheck
import React from "react";
import { Lock } from "lucide-react";

export default function SheetLockScreen({ message }: { message?: string }) {
  return (
    <div className="min-h-screen flex items-center justify-center bg-slate-100 p-4">
      <div className="text-center max-w-sm">
        <Lock className="h-10 w-10 text-slate-400 mx-auto mb-3" />
        <h1 className="text-lg font-semibold mb-1">This link is invalid or has expired</h1>
        <p className="text-sm text-muted-foreground">
          {message || "Ask the organizer to send you a fresh share link."}
        </p>
      </div>
    </div>
  );
}
